import { type DatasetRow } from '@blaze-shared/schema-domain';

/**
 * Prepares the data for the page context.
 * @param data data input to be prepared; it can be an object or an array of objects, can also be null (no data), but cannot be undefined
 * @returns a unified row - always a DataRow or null
 * @throws an error if the data is not valid
 */
export function preparePageContextData(data: unknown): DatasetRow | null {
  if (data === undefined) {
    throw new Error('Data is undefined');
  }

  let outputData = data;

  // Extract the first row if the data is an array
  if (Array.isArray(outputData)) {
    if (outputData.length > 1) {
      throw new Error('Data is not a single row');
    }

    // Take the first row; for empty array, use null (no row)
    outputData = outputData.length === 1 ? outputData[0] : null;
  }

  if (outputData === undefined) {
    throw new Error('Data is missing');
  }

  if (typeof outputData !== 'object') {
    throw new Error('Data is not an object');
  }

  return outputData;
}
